


































import { Vue, Component, Prop } from 'vue-property-decorator';
import RoundButton from '@/components/RoundButton.vue';
import { api } from '@/api';

@Component({
  components: {
    RoundButton
  }
})
export default class FileUpload extends Vue {
  // Props
  @Prop({ type: String, default: '' }) public accept!: string;
  @Prop(String) public apiUrl!: string;
  @Prop({ type: Boolean, default: true }) public multiple!: boolean;
  @Prop({ type: Boolean, default: false }) public readonly isReadOnly!: boolean;
  @Prop({ type: Boolean, default: true }) public readonly customSave!: boolean;

  public files: Blob[] = [];
  public dragging = false;
  public errorMessages = '';

  public getPlaceholder() {
    if (!this.isReadOnly) {
      if (this.multiple) {
        return 'Sleep of selecteer de bestanden hier';
      } else {
        return 'Sleep of selecteer het bestand hier';
      }
    } else {
      return '';
    }
  }

  public hasFiles() {
    // console.log('FileUpload.hasFiles');
    const fileOrFiles: any = this.files;
    return (fileOrFiles.length > 0) || (fileOrFiles.size > 0);
  }
  public deleteFile(index) {
    // console.log('FileUpload.deleteFile');
    this.errorMessages = '';
    this.files.splice(index, 1);
  }

  public addDropFile(e) {
    // console.log('FileUpload.addDropFile');
    if (!this.isReadOnly) {
      this.errorMessages = '';
      this.dragging = false;
      const transfer: any = e.dataTransfer;
      // console.log('FileUpload.addDropFile', transfer);
      const files: FileList = transfer.files;
      if (!this.multiple && (this.files.length > 0 || files.length > 1)) {
        this.errorMessages = 'Het maximaal aantal toegelaten bestanden is 1.';
      } else {
        const acceptedFiles = this.accept.split(/[\s,]+/); // Remove spaces
        // tslint:disable-next-line: prefer-for-of
        for (let i = 0; i < files.length; i++) {
          let accepted = false;
          // tslint:disable-next-line: prefer-for-of
          for (let j = 0; j < acceptedFiles.length; j++) {
            if (files[i].type.match(acceptedFiles[j])) {
              accepted = true;
              this.files.push(files[i]);
              break;
            }
          }
          if (!accepted) {
            this.errorMessages = '1 of meerdere bestanden zijn niet toegevoegd wegens fout formaat.';
          }
        }
      }
    }
  }

  public async save() {
    // console.log('FileUpload.save');
    this.errorMessages = '';
    const formData = new FormData();
    if (Array.isArray(this.files)) { // depending on multiple prop, it can be list or single element
      this.files.forEach(f => formData.append('file', f));
    } else {
      formData.append('file', this.files);
    }
    const response = await api.uploadFile(this.$store, this.apiUrl, formData);
    if (response) {
      this.$emit('uploaded', response.data);
    }
    this.files = [];
  }
}
